export default __webpack_public_path__ + "static/media/swf.15bf9552.svg";